import { useField } from 'formik';
import { Select, SelectType } from '@/components/form/fields/Select/Select';
import { ResponseErrorType } from '@/types/sharedTypes';
import { getFieldError } from '@/helpers/formHelpers/formHelpers';

interface FormikSelectType extends Omit<SelectType, 'apiError'> {
  name: string;
  apiError?: ResponseErrorType;
}

export const FormikSelect = ({
  placeholder,
  options,
  label,
  name,
  apiError,
  isSearchable,
  postfixLabel,
  isLoading,
  hasPortal,
  disabled,
}: FormikSelectType) => {
  const [field, meta, { setValue }] = useField(name);

  const { error, apiError: apiErrorMessage } = getFieldError(name, meta, apiError);

  const onChange = (newValue) => {
    setValue(newValue);
  };

  const onBlur = (event) => {
    field.onBlur(event);
  };

  return (
    <Select
      {...field}
      placeholder={placeholder}
      options={options}
      isSearchable={isSearchable}
      label={label}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      apiError={apiErrorMessage}
      isLoading={isLoading}
      postfixLabel={postfixLabel}
      hasPortal={hasPortal}
      disabled={disabled}
    />
  );
};
